
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import SvgImgV3 from "@/components/videoPaly/video-play-v3.vue";
import { ReportShowConfigV5Item } from "@/lib/model/exam/result";
import { CandidateNewResult } from "@/lib/model/exam/candidate-result";

enum cheatEnum {
  "appearanceDetection" = "仪容仪表检测"
}

const cheatKeys = ["hairDetection", "dressingDetection", "smokeDetection"];

//异常项 默认文案
const errorEnumText = ["未检测", "未通过", "通过"];

//手部
enum enumFinger {
  "未按要求拍摄" = 0,
  "通过" = 1,
  "有异常" = 2,
  "考察项未配置" = 255
}

const errorEnumTextEX = {
  hairDetection: ["未按要求拍摄", "通过", "检测到染发"],
  dressingDetection: ["未按要求拍摄", "通过", "着装不符合要求"],
  smokeDetection: ["未按要求拍摄", "通过", "检测到吸烟行为"]
};

@Component({
  components: { SvgImgV3 }
})
export default class PaperResultReport extends Vue {
  @Prop() index!: number;
  @Prop({ default: () => new CandidateNewResult() }) all!: CandidateNewResult;
  @Prop({ default: false }) pdfIng!: boolean;
  @Prop({ default: () => new ReportShowConfigV5Item() })
  option!: ReportShowConfigV5Item;
  connectCode = "";
  appearanceList: any = [];

  showVideo = false;

  @Watch("all")
  getAll(nval: CandidateNewResult) {
    this.getFingerList();
  }

  isIphone = false; // iphone播放按钮和版本也有关，目前试着13一直显示，14以上不显示

  get needShow() {
    return (
      this.all.report.hairDetection._isAssignedFlag ||
      this.all.report.dressingDetection._isAssignedFlag ||
      this.all.report.smokeDetection._isAssignedFlag
    );
  }

  getFontCode(index: number) {
    return ["&#xe71d;", "&#xe71c;", "&#xe71f;"][index];
  }

  getStatus(str: string) {
    return str ? 1 : 2;
  }

  //
  mounted() {
    this.getFingerList();
    document.addEventListener("fullscreenchange", this.checkFullscreen);
  }
  beforeDestroy() {
    document.removeEventListener("fullscreenchange", this.checkFullscreen);
  }
  //全屏视频修改填充样式
  isVideoFullscreen = false;
  scrollPosition = 0;
  get objectFit() {
    return this.isVideoFullscreen ? "contain" : "cover";
  }
  checkFullscreen() {
    this.isVideoFullscreen =
      document.fullscreenElement !== null &&
      document.fullscreenElement.tagName === "VIDEO";
  }

  appearanceResText(str: string) {
    return errorEnumTextEX[str][this.all.report[str]?.resultStatus];
  }

  appearanceText(i: number) {
    return ["未检测", "通过", "未通过"][i];
  }

  openImg(url: string) {
    this.$emit("openImg", url);
  }

  getFingerList() {
    this.appearanceList = [];
    this.all.report.errorInfoList.forEach(item => {
      if (cheatKeys.includes(item.task)) {
        this.appearanceList.push({
          name: cheatEnum[item.task],
          type: item.result,
          task: item.task,
          result: errorEnumText[item.result],
          value: item.resMessage || errorEnumText[item.result]
        });
      }
    });
    this.$emit("getFingerList", this.appearanceList);
  }
}
